import { useState } from 'react';
import { useForm } from 'react-hook-form';

import Layout from '../PatientList/components/Layout';
import { postUpdatePatient } from '../PatientList/api';
import useNotification from 'hooks/useNotification';

import Header from './Header';
import PathologyList from './PathologyList';
import RadiologyList from './RadiologyList';
import MedicationList from './MedicationList';
import PatientInfo from './PatientInfo';
import { IUpdatePatient } from './type';
import EtcList from './EtcList';
import useUser from 'store/user/useUser';

function PatientUpdate() {
  const [isRefresh, setIsRefresh] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSearched, setIsSearched] = useState(false);
  const { student_uuid: userId } = useUser();

  const { onRequired, onResultCode, onFail, onSuccess } = useNotification();

  const { handleSubmit, register, reset, watch, setValue, getValues } =
    useForm<IUpdatePatient>({
      defaultValues: { patient: { gender: 1 } },
    });
  const formProps = { setValue, register, getValues };

  const onSubmit = async (data: IUpdatePatient) => {
    const { patient, pathology, radiology, medication, miscellaneous } = data;

    if (!patient.college) onRequired('CREATE.SCHOOL');
    if (!patient.diseaseMain) onRequired('CREATE.MAINDISEASE');

    postUpdatePatient({
      patient,
      pathology,
      medication,
      miscellaneous,
      user_id: userId,
    })
      .then(({ data: { rc } }) => {
        if (rc !== 1) return onResultCode(rc);
        setIsRefresh(true);
        reset({ patient: { gender: 1 } });
        onSuccess('Successfully updated virtual patient.');
      })
      .catch(e => onFail('가상환자 생성 실패하였습니다', e))
      .finally(() => {
        setIsLoading(false);
        setIsSearched(false);
        setTimeout(() => setIsRefresh(false), 300);
      });
  };

  const Form = () => {
    if (isRefresh) return null;
    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <Header routeName="Edit Virtual Patient" isLoading={isLoading} />
        <PatientInfo
          {...formProps}
          reset={reset}
          watch={watch}
          setIsSearched={setIsSearched}
          isSearched={isSearched}
        />
        <PathologyList {...formProps} defaultList={getValues('pathology')} />
        <RadiologyList {...formProps} defaultList={getValues('radiology')} />
        <MedicationList {...formProps} defaultList={getValues('medication')} />
        <EtcList {...formProps} defaultList={getValues('miscellaneous')} />
      </form>
    );
  };

  return (
    <Layout isLoading={isRefresh} currentMenu={'Edit Virtual Patient'}>
      <Form />
    </Layout>
  );
}

export default PatientUpdate;
